<template>
  <property-list />
</template>

<script>
  import PropertyList from '@/components/property/PropertyList'

  export default {
    components: {
      PropertyList
    }
  }
</script>
